import styled from '@emotion/styled';
import { screenSizes } from '../Literals';

export const CheckInComponent = styled.div`
  margin: 0 auto;
  width: 70%;
  background-color: #fff;
  border-radius: 22px;
  height: auto;
  padding: 1.1rem;

  .CheckIn__title {
    margin: 0.75rem 0 0.35rem;
    color: #2596c2;
    font-size: 1.75rem;
    font-weight: 700;
  }

  .CheckIn__subtitle {
    margin: 0.5rem 0 1rem;
    color: #1a2a33;
    font-size: 1.15rem;
    font-weight: 600;
  }

  .info {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin: 0;

    .profilePhoto {
      flex: 0 0 150px;
      width: 150px;
      height: 150px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 12px;
      border: 1px solid #e0e0e0;
      background-color: #f5f5f5;
      margin: 0;
    }

    .data {
      margin: 0;
      flex: 1;
      min-width: 0;

      &.pic {
        display: flex;
        flex-direction: column;
      }

      p {
        display: block;
        margin: 0.35rem 0;
      }
    }

    p {
      strong {
        margin: 0 0.35rem 0 0;
      }
    }
  }
  .photo {
    margin: 20px 0;
  }
  @media only screen and (max-width: ${screenSizes.tablet}) {
    width: 95%;
    .info {
      flex-direction: column;
      align-items: center;
      text-align: center;

      .profilePhoto {
        flex-basis: 140px;
        width: 140px;
        height: 140px;
      }

      .data p {
        width: 100%;
      }
    }
  }
`;

export const GuestIdFormComp = styled.div`
  background-color: white;
  padding: 20px 40px;
  border-radius: 10px;

  .GuestIdForm__title {
    margin: 0 0 1.25rem;
    color: #2596c2;
    font-size: 1.75rem;
    font-weight: 700;
    text-align: center;
  }

  form {
    max-width: 300px;
    margin: 0 auto;
  }
  .Registration__input {
    padding: 0;
  }
  .ui.button {
    margin: 5px 0 0 0;
  }
`;
